import { Tutorial } from 'features/tutorials/ts';

export const TUTORIAL_LIST: Tutorial[] = [
  {
    id: 'panel1',
    title: 'tutorialList.panel1.title',
    list: {
      item1: {
        title: 'tutorialList.panel1.list.item1.title',
      },
      item2: {
        title: 'tutorialList.panel1.list.item2.title',
      },
      item3: {
        title: 'tutorialList.panel1.list.item3.title',
        subList: ['tutorialList.panel1.list.item3.subList.subItem1', 'tutorialList.panel1.list.item3.subList.subItem2'],
      },
      item4: {
        title: 'tutorialList.panel1.list.item4.title',
        subList: [
          'tutorialList.panel1.list.item4.subList.subItem1',
          'tutorialList.panel1.list.item4.subList.subItem2',
          'tutorialList.panel1.list.item4.subList.subItem3',
          'tutorialList.panel1.list.item4.subList.subItem4',
          'tutorialList.panel1.list.item4.subList.subItem5',
        ],
      },
      item5: {
        title: 'tutorialList.panel1.list.item5.title',
      },
      item6: {
        title: 'tutorialList.panel1.list.item6.title',
      },
    },
  },
  {
    id: 'panel2',
    title: 'tutorialList.panel2.title',
    list: {
      item1: {
        title: 'tutorialList.panel2.list.item1.title',
      },
      item2: {
        title: 'tutorialList.panel2.list.item2.title',
      },
      item3: {
        title: 'tutorialList.panel2.list.item3.title',
      },
      item4: {
        title: 'tutorialList.panel2.list.item4.title',
      },
      item5: {
        title: 'tutorialList.panel2.list.item5.title',
      },
    },
  },
  {
    id: 'panel3',
    title: 'tutorialList.panel3.title',
    list: {
      item1: {
        title: 'tutorialList.panel3.list.item1.title',
      },
      item2: {
        title: 'tutorialList.panel3.list.item2.title',
      },
      item3: {
        title: 'tutorialList.panel3.list.item3.title',
      },
      item4: {
        title: 'tutorialList.panel3.list.item4.title',
      },
      item5: {
        title: 'tutorialList.panel3.list.item5.title',
      },
      item6: {
        title: 'tutorialList.panel3.list.item6.title',
      },
      item7: {
        title: 'tutorialList.panel3.list.item7.title',
      },
    },
  },
  {
    id: 'panel4',
    title: 'tutorialList.panel4.title',
    list: {
      item1: {
        title: 'tutorialList.panel4.list.item1.title',
      },
      item2: {
        title: 'tutorialList.panel4.list.item2.title',
      },
      item3: {
        title: 'tutorialList.panel4.list.item3.title',
        subList: [
          'tutorialList.panel4.list.item3.subList.subItem1',
          'tutorialList.panel4.list.item3.subList.subItem2',
          'tutorialList.panel4.list.item3.subList.subItem3',
        ],
      },
    },
  },
  {
    id: 'panel5',
    title: 'tutorialList.panel5.title',
    list: {
      item1: {
        title: 'tutorialList.panel5.list.item1.title',
      },
      item2: {
        title: 'tutorialList.panel5.list.item2.title',
      },
      item3: {
        title: 'tutorialList.panel5.list.item3.title',
      },
    },
  },
  {
    id: 'panel6',
    title: 'tutorialList.panel6.title',
    list: {
      item1: {
        title: 'tutorialList.panel6.list.item1.title',
      },
      item2: {
        title: 'tutorialList.panel6.list.item2.title',
      },
      item3: {
        title: 'tutorialList.panel6.list.item3.title',
      },
      item4: {
        title: 'tutorialList.panel6.list.item4.title',
      },
    },
  },
  {
    id: 'panel7',
    title: 'tutorialList.panel7.title',
    text: 'tutorialList.panel7.text',
    list: {
      item1: {
        title: 'tutorialList.panel7.list.item1.title',
      },
      item2: {
        title: 'tutorialList.panel7.list.item2.title',
      },
      item3: {
        title: 'tutorialList.panel7.list.item3.title',
      },
      item4: {
        title: 'tutorialList.panel7.list.item4.title',
      },
      item5: {
        title: 'tutorialList.panel7.list.item5.title',
      },
      item6: {
        title: 'tutorialList.panel7.list.item6.title',
      },
      item7: {
        title: 'tutorialList.panel7.list.item7.title',
      },
    },
  },
  {
    id: 'panel8',
    title: 'tutorialList.panel8.title',
    text: 'tutorialList.panel8.text',
  },
];
